import AbstractService from "./abstract.service"
import BillingInfoTransformer, { baseUri } from "@/transformers/billingInfo.transformer"

export const baseUrl = "/api/billing-infos"

class BillingInfoService extends AbstractService {
  constructor() {
    super({
      baseUri,
      transformer: BillingInfoTransformer
      // methodWithoutAuth: "all"
    })
  }
}

const billingInfoService = new BillingInfoService()

export default billingInfoService
